import { get } from 'sortablejs'
import { createAPI } from '../../common'

export default {

    // 获取根节点
    getRoot: (config) => createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60gpmefst0sppu', 'get', config),
    // 获取子节点
    getSubs: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0epn0gpmefst', 'get', config),
    //获取folder下的操作
    getActionFolder: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs', 'get', config),
    //获取folder下的操作
    getPermissionAll: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
            'get',
            config
        ),
    // postActionFolder: (config) =>
    //     createAPI(
    //         '/mediax-newsplan/e5/admin/permissions/actions/folder',
    //         'post',
    //         config
    //     ),
    //保存权限操作
    postPermission: (config) =>
        createAPI('customEncryptApiName-1/0nfejby.ofxtqmbo0f60benjo0qfsnjttjpot0bdujpot0gpmefs',
            'post',
            config
        ),

}
